import * as React from 'react';
import { Button, Divider, ListSubheader } from '@mui/material';
import { NavLink } from '../..';

export const FooterMenuItem = ({ link, onClick }: { link: NavLink; onClick: () => void }) => {
  const menuItemStyles = {
    mr: 4
  };

  if (link.separator) {
    return (
      <Divider
        sx={{
          height: 28,
          m: 0.5,
          verticalAlign: 'middle'
        }}
        orientation="vertical"
      />
    );
  }

  if (!link.path) {
    return <ListSubheader sx={{ lineHeight: 'inherit', ...menuItemStyles }}>{link.text}</ListSubheader>;
  }

  return (
    <Button
      href={link.path}
      onClick={onClick}
      variant={link.variant ?? 'text'}
      color={link.color ?? 'secondary'}
      sx={menuItemStyles}
    >
      {link.text}
    </Button>
  );
};
